window.jQuery = window.$ = jQuery;

(function () {
    window.AddData = {};

    window.AddData = function (data, classe) {
        $('#datepicker').val('');
        var values = $("input[name='scadenza[]']").map(function(){return $(this).val();}).get();
        console.log(values);
        if(jQuery.inArray(data, values) !== -1){
            Notify.toastError('Data già selezionata');
        }
        else{
            let template = $('#template_data').html();
            let html = Mustache.render(template, {
                'data': data,
                'classe': classe,
            });

            $('.scadenze-aggiunte').append(html);
        }

    }
})();
